"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteroidMining = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var AsteroidMining = (function (_super) {
    __extends(AsteroidMining, _super);
    function AsteroidMining() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ASTEROID_MINING,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            cost: 30,
            metadata: {
                description: 'Increase your titanium production 2 steps.',
                cardNumber: '040',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.production(function (pb) { return pb.titanium(2); }); }),
                victoryPoints: 2,
            },
        }) || this;
    }
    AsteroidMining.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 2);
        return undefined;
    };
    AsteroidMining.prototype.getVictoryPoints = function () {
        return 2;
    };
    return AsteroidMining;
}(Card_1.Card));
exports.AsteroidMining = AsteroidMining;
